import React from "react";
import { useContext, useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';

//import icons from heroicons
import { DocumentTextIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

//import global components
import { Star, Modal, ModalActionConfirm } from '../../../../imports';

import { Tab } from '@headlessui/react'

//import services
import { ObtenerTecnologia, EditarTecnologiaPersona, EliminarTecnologiaPersona, ObtenerTecnologiasPorIdEspecializacion } from '../../../../servicios/ServicioTecnologia';

import { ObtenerEspecialidades } from '../../../../servicios/ServicioEspecializacion';

//component to render each tab from panel with specialty category
const CustomTabComponent = ({ idEspecializacion, onChangeListTech, listTechnologies, listRating, setListRating, allowEdit, EliminarTecnologia, userCompleteCV, idCurriculum }) => {

    async function callAsyncList() {
        await onChangeListTech(idEspecializacion);
    }

    useState(() => {
        callAsyncList();
    }, [])

    return (
        <>
            {/* Grid de 3 columnas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 py-4">
                {Array.isArray(listTechnologies) && listTechnologies.length > 0 ? (
                    listTechnologies.map((option, index) => (
                        <div className="w-full px-2" key={option.idTecnologia}>
                            <Star
                                index={index}
                                id={option.idTecnologia}
                                technologieName={option.tecnologia}
                                techList={listRating}
                                setListRating={setListRating}
                                allowEdit={allowEdit}
                                deleteElementCV={EliminarTecnologia}
                                userCompleteCV={userCompleteCV}
                                idCurriculum={idCurriculum}
                            />
                        </div>
                    ))
                ) : (
                    <div className="col-span-3 text-center text-gray-500 py-8">
                        No hay tecnologías disponibles en esta categoría
                    </div>
                )}
            </div>
        </>
    )
}

export default function Tecnologias({ validationMessages, userData, setUserData, finalData, stateInfoPersonal, setstateInfoPersonal, stateEducacion, setstateEducacion, stateTech, setstateTech, otherTechnologiesData, setOtherTechnologiesData, allowEdit, listTechnologiesByPerson, technologieDataEdit, setTechnologieDataEdit, idCurriculum, isFirstLoadTechnologies, setIsFirstLoadTechnologies }) {

    const alertCtx = useContext(AlertContext);
    const [listTechnologies, setListTechnologies] = useState([]);
    const [listRating, setListRating] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(name, e.target.value)
        setUserData({ ...userData, [name]: value });
    };

    const handleOtherTechnologies = (e) => {
        const { name, value } = e.target;
        setOtherTechnologiesData({ ...otherTechnologiesData, [name]: value });
    };

    const handleChangeUserCompleteCV = (e) => {
        const { name, value } = e.target;
        if (technologieDataEdit) {
            setTechnologieDataEdit({ ...technologieDataEdit, [name]: value })
        }
    };

    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [specialtyList, setSpecialtyList] = useState([]);

    const { register, getValues, setValue, handleSubmit, formState } = useForm({
        mode: "all",
        defaultValues: {
            otherTechnologies: '',
        }
    });
    const { errors } = formState;
    const { isValid } = formState;
    const [validations, setValidations] = useState([]);

    async function getTechnologies() {
        const response = await ObtenerTecnologia();
        setListTechnologies(response || []);
    }

    async function EliminarTecnologia(idTecnologiaPersona, idPersona) {
        const response = await EliminarTecnologiaPersona(idTecnologiaPersona, idPersona);
        return response;
    }

    async function getSpecialties() {
        const response = await ObtenerEspecialidades();
        setSpecialtyList(response);
    }

    async function changeListTech(index) {
        const response = await ObtenerTecnologiasPorIdEspecializacion(index);
        setListTechnologies(response || []);
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    const EditarTecnologiasPersona = async (e) => {
        console.log("tec: ", listRating);
        if (listRating?.length >= 0) {
            const tecnologiasData = listRating.map(tecnologia => ({
                idTecnologia: tecnologia.idTecnologia,
                expertiz: tecnologia.expertiz,
                otrasTecnologias: getValues("otherTechnologies"),
                idPersona: idCurriculum
            }));

            const tecnologiasResponse = await EditarTecnologiaPersona(tecnologiasData);

            if (tecnologiasResponse.indicador === 0) {
                alertCtx.success(tecnologiasResponse.mensaje);
                setShowConfirmSaveModal(false);
            }
        }
    }

    const keepValuesFromListByPerson = () => {
        const otherTechnologies = getValues("otherTechnologies");
        if (technologieDataEdit) {
            setTechnologieDataEdit({
                ...technologieDataEdit, ["otherTechnologies"]: otherTechnologies, listRating
            })
        }
    }

    useState(() => {
        getSpecialties();
        setValidations(validationMessages);
        if (userCompleteCV === "true" && isFirstLoadTechnologies || allowEdit === true && isFirstLoadTechnologies) {
            if (listTechnologiesByPerson?.length > 0) {
                setIsFirstLoadTechnologies(false)
                setListRating(listTechnologiesByPerson);
                setValue("otherTechnologies", listTechnologiesByPerson[listTechnologiesByPerson.length - 1]?.otrasTecnologias)
            }
        }
    }, [])

    useEffect(() => {
        if (userCompleteCV === "true" || allowEdit === true) {
            if (listRating?.length > 0) {
                if (technologieDataEdit) {
                    setTechnologieDataEdit(listRating);
                }
            } else {
                if (technologieDataEdit) {
                    setListRating(technologieDataEdit?.listRating);
                    setValue("otherTechnologies", technologieDataEdit?.otherTechnologies)
                }
            }
        } else {
            if (listRating?.length > 0) {
                setstateTech(true);
                setUserData({ ...userData, "listTechnologies": listRating })
            } else {
                setstateTech(false);
                if (finalData["listTechnologies"]?.length > 0) {
                    setListRating(finalData["listTechnologies"])
                }
            }
        }

        return (() => {
            if (userCompleteCV === "true" || allowEdit === true) {
                if (isFirstLoadTechnologies) {
                    setIsFirstLoadTechnologies(false);
                }
                if (technologieDataEdit) {
                    setTechnologieDataEdit(listRating);
                }
                keepValuesFromListByPerson();
            } else {
                if (!listTechnologiesByPerson && listRating.length > 0) {
                    setUserData({ ...userData, "listTechnologies": listRating })
                }
            }
        })
    }, [listRating])

    return (
        <div className="w-full px-4 py-6">

            <div
                className="
            relative
            w-full
            bg-white
            rounded-3xl
            border
            border-gray-200
            shadow-2xl
            overflow-hidden
        "
            >

                {/* Decoraciones tecnológicas externas */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600 via-red-400 to-red-600"></div>

                <div className="absolute -top-20 -right-20 w-60 h-60 bg-red-100 rounded-full blur-3xl opacity-40"></div>

                <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-gray-200 rounded-full blur-3xl opacity-40"></div>


                <div className="relative container mx-auto">


                    {/* HEADER TECNOLÓGICO */}
                    <div
                        className="
                    relative
                    px-10
                    py-10
                    border-b
                    border-gray-200
                    bg-gradient-to-r
                    from-white
                    via-gray-50
                    to-white
                    overflow-hidden
                "
                    >

                        {/* líneas tipo circuito */}
                        <div className="absolute top-5 right-10 w-32 h-px bg-red-200"></div>
                        <div className="absolute top-10 right-20 w-20 h-px bg-gray-300"></div>
                        <div className="absolute bottom-8 left-10 w-24 h-px bg-red-200"></div>


                        <div className="flex justify-between items-center">


                            <div>

                                <h1 className="
                            text-4xl
                            font-extrabold
                            text-gray-800
                            tracking-tight
                        ">
                                    Tecnologías
                                </h1>


                                <p className="
                            mt-3
                            text-gray-500
                            max-w-xl
                        ">
                                    Seleccione las tecnologías que domina e indique su nivel de experiencia.
                                </p>


                            </div>



                            <div className="hidden lg:flex">

                                <div
                                    className="
                                relative
                                w-28
                                h-28
                                rounded-3xl
                                bg-white
                                border
                                border-red-200
                                shadow-xl
                                flex
                                items-center
                                justify-center
                            "
                                >

                                    <div className="
                                absolute
                                inset-3
                                rounded-2xl
                                border
                                border-dashed
                                border-red-200
                            ">
                                    </div>


                                    <DocumentTextIcon
                                        className="
                                    relative
                                    w-12
                                    h-12
                                    text-red-600
                                "
                                    />

                                </div>

                            </div>


                        </div>


                    </div>




                    {/* MODAL ORIGINAL */}
                    <Modal
                        isVisible={showConfirmSaveModal}
                        onClose={() => { setShowConfirmSaveModal(false) }}
                        handleSubmit={() => null}
                        onSaveOptions={null}
                        showFotter={false}
                        showCloseIcon={false}
                    >
                        <ModalActionConfirm
                            onSaveAction={EditarTecnologiasPersona}
                            actionType={actionTypeConfirmModal}
                            setshowConfirmModal={setShowConfirmSaveModal}
                        />
                    </Modal>




                    {/* BOTON ACTUALIZAR */}
                    <div className="flex justify-end px-10 mt-6">

                        {!allowEdit && userCompleteCV === "true" && (

                            <button
                                onClick={() => {
                                    setActionTypeConfirmModal("Editar");
                                    setShowConfirmSaveModal(true);
                                }}
                                type="button"
                                className="
                            group
                            relative
                            px-8
                            py-3
                            rounded-xl
                            bg-red-600
                            text-white
                            font-semibold
                            shadow-lg
                            hover:shadow-red-300
                            hover:scale-105
                            transition-all
                            duration-300
                            overflow-hidden
                        "
                            >

                                <span className="
                            absolute
                            inset-0
                            bg-white
                            opacity-0
                            group-hover:opacity-10
                            transition
                        ">
                                </span>

                                Actualizar

                            </button>

                        )}

                    </div>





                    {/* TABS */}

                    <div className="px-10 py-8">

                        <Tab.Group
                            selectedIndex={selectedIndex}
                            onChange={setSelectedIndex}
                        >


                            <div className="overflow-x-auto">


                                <Tab.List
                                    className="
                                flex
                                gap-3
                                p-3
                                rounded-2xl
                                bg-gray-50
                                border
                                border-gray-200
                                shadow-inner
                            "
                                >

                                    {specialtyList.map((value, index) => (

                                        <Tab
                                            key={index}
                                            className={({ selected }) =>
                                                classNames(

                                                    "px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-300 whitespace-nowrap",

                                                    selected
                                                        ?
                                                        "bg-red-600 text-white shadow-lg shadow-red-200 scale-105"
                                                        :
                                                        "bg-white text-gray-500 border border-gray-200 hover:text-red-600 hover:border-red-300"

                                                )
                                            }
                                        >

                                            {value.nombreEspecializacion}

                                        </Tab>

                                    ))}


                                </Tab.List>


                            </div>




                            <Tab.Panels className="mt-6">


                                {specialtyList.map((value, index) => (

                                    <Tab.Panel key={index}>


                                        <CustomTabComponent
                                            key={value.idEspecializacion}
                                            idEspecializacion={value.idEspecializacion}
                                            onChangeListTech={changeListTech}
                                            listTechnologies={listTechnologies}
                                            listRating={listRating}
                                            setListRating={setListRating}
                                            allowEdit={allowEdit}
                                            userCompleteCV={userCompleteCV}
                                            EliminarTecnologia={EliminarTecnologia}
                                            idCurriculum={idCurriculum}
                                        />


                                    </Tab.Panel>

                                ))}


                            </Tab.Panels>



                        </Tab.Group>


                    </div>





                    {/* OTRAS TECNOLOGIAS */}

                    <form className="px-10 pb-10">


                        <div className="
                    flex
                    items-center
                    py-8
                ">

                            <div className="flex-1 h-px bg-gray-200"></div>


                            <div className="
                        mx-5
                        text-xs
                        uppercase
                        tracking-[4px]
                        font-bold
                        text-gray-400
                    ">
                                Más información
                            </div>


                            <div className="flex-1 h-px bg-gray-200"></div>


                        </div>



                        <div className="
                    bg-gradient-to-br
                    from-gray-50
                    to-white
                    rounded-3xl
                    border
                    border-gray-200
                    shadow-lg
                    p-8
                ">


                            <label className="
                        block
                        mb-3
                        text-sm
                        font-bold
                        text-gray-800
                    ">
                                Otras tecnologías
                            </label>



                            <div className="relative">


                                <textarea
                                    type="textarea"
                                    name="otherTechnologies"
                                    value={userCompleteCV === "false" ? otherTechnologiesData["otherTechnologies"] : getValues("otherTechnologies")}
                                    {...register('otherTechnologies', {
                                        onChange: userCompleteCV === "true"
                                            ?
                                            handleChangeUserCompleteCV
                                            :
                                            handleOtherTechnologies,
                                        required: false,
                                        maxLength: 1000
                                    })}
                                    id="otherTechnologies"
                                    disabled={allowEdit}
                                    className="
                                w-full
                                rounded-2xl
                                border
                                border-gray-300
                                bg-white
                                p-5
                                text-sm
                                text-gray-700
                                shadow-inner
                                focus:border-red-500
                                focus:ring-4
                                focus:ring-red-100
                                transition-all
                            "
                                    placeholder="Otras tecnologías"
                                    rows="3"
                                />


                                <DocumentTextIcon
                                    className="
                                absolute
                                right-4
                                top-4
                                h-6
                                w-6
                                text-red-400
                            "
                                />


                            </div>


                        </div>


                    </form>


                </div>

            </div>

        </div>
    )
}